import { FormlyFieldConfig } from '@ngx-formly/core';

export function minlengthValidationMessages(err, field) {
    return `Este campo deve conter no minímo ${field.templateOptions.minLength} caracteres`;
}

export function minValidatorMessage(err: { min: number, actual: number }, field: FormlyFieldConfig) {
    return `Valor "${err.actual}" é inválido`;
}
